import React from "react";

import l10n from "../../l10n/localization";
import Tabs from "react-toolbox/lib/tabs/Tabs";
import Tab from "react-toolbox/lib/tabs/Tab";
import UnderwriterForm from "../forms/UnderwriterForm";
import * as utils from "../../utils/utils";
import RateTable from "./rates/RateTable";
import {connect} from "react-redux";

class UnderwriterTabs extends React.Component {

    state = {
        activeTab: 0,
    };


    handleTabChange = (activeTab) => {
        this.setState({activeTab});
    };

    render() {
        let underwriter = null;
        let isNew = false;

        if ((!utils.notNullNorUndefined(this.props.item) || !utils.notNullNorUndefined(this.props.item.item) || !utils.notNullNorUndefined(this.props.item.item.id)) && this.props.newlyCreatedElement === null) {
            isNew = true;
        } else {
            underwriter = {...this.props.item.item};
            if (this.props.newlyCreatedElement !== null) {
                underwriter = this.props.underwriters.getById(this.props.newlyCreatedElement);
                if (!utils.notNullNorUndefined(underwriter)) {
                    underwriter = true;
                }
            } else {
                if (utils.notNullNorUndefined(this.props.item) && utils.notNullNorUndefined(this.props.item.item)) {
                    underwriter = this.props.underwriters.getById(this.props.item.item.id);
                }
            }
        }

        return (
            <section className="underwriter-tabs">
                {!isNew && <h1>Underwriter {utils.notNullNorUndefined(underwriter) && " - " + underwriter.name}</h1>}
                {isNew && <h1>New Underwriter</h1>}
                <Tabs index={this.state.activeTab} onChange={this.handleTabChange}>
                    <Tab label={l10n.common.general}><UnderwriterForm item={{...this.props.item, item: underwriter}} depth={this.props.depth} displayTitle={false} /></Tab>
                    <Tab label={l10n.underwriter.prefTitle} disabled={isNew}> {!isNew && <RateTable underwriter={{...this.props.item, item: underwriter}} depth={this.props.depth} {...this.props} />}</Tab>
                </Tabs>
            </section>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        newlyCreatedElement: state.creation.newlyCreatedUnderwriter,
        underwriters: state.underwriter.underwriters,
        deletingUnderwriter: state.underwriter.deleting
    });
})(UnderwriterTabs);


// WEBPACK FOOTER //
// ./src/components/underwriter/UnderwriterTabs.js